<template>
	<div @keydown.enter="handleSubmit">
		<Form ref="loginForm" :model="phoneFormItem" :rules="rules">
            
            <FormItem prop="phoneNumber">
                <Input v-model="phoneFormItem.phoneNumber" maxlength="11" placeholder="请输入手机号">
                    <span slot="prepend">
                        <Icon :size="16" type="md-phone-portrait" />
                    </span>
                </Input>
            </FormItem>
			<FormItem class="loginBtn">
				<Button @click="handleSubmit" type="primary" long>点击验证</Button>
			</FormItem>
		</Form>
	</div>
</template>
<script>
import api from "@/api";
import ls from "store2";
export default {
    name: "loginForm",
    props: {
        unionid: String
    },
    data() {
        return {
            showPcode: true,
            count: 60,
            agreement: false,
            phoneFormItem: {
                phoneNumber: ""
            }
        };
    },
    computed: {
        rules() {
            return {
                phoneNumber: [
                    { required: true, message: '请填写手机号', trigger: 'blur' }
                ]
            };
        }
    },
    methods: {
        handleSubmit(){
            let datas ={
                type: 'loginPhone',
                value: this.phoneFormItem.phoneNumber,
                unionid: this.unionid
            }
            api.axss("post", "/ocm-admin/verify", datas).then(res=>{
                if(res.code === '00000') {
                    const resType = res.data.verifyLoginPhoneResult.type
                    if(resType === "-1") { // 美孚用户
                        this.$Message.success('此账号为美孚用户, 即将跳转单点登录');
                        setTimeout(() => {
                            this.$router.push('/admin/login')
                        }, 1000);
                    }else if(resType === '0') {
                        // 管理员
                        this.$Message.success('验证成功,请继续输入邮箱验证');
                        this.$router.push(`/customer/login?wxlog=0&role=admin&uid=${this.unionid}&phone=${datas.value}`)
                    }else if(resType === '1') {
                        // 用户
                        this.$Message.success('验证成功,请继续输入验证码');
                        this.$router.push(`/customer/login?wxlog=0&role=user&uid=${this.unionid}&phone=${datas.value}`)
                    }
                } else {
                    this.$Message.error(res.msg);
                }
            })
        },
    }
};
</script>
<style lang="less">
    .codeItem {
        position: relative;
        .phoneCode {
            position: absolute;
            top: 1px;
            right: 1px;
            z-index: 2;
            height: 30px;
            border-radius: 4px;
            padding: 0 10px;
            span {
                color: #0c479d
            }
        }
    }
    .loginBtn {
        margin: 30px 0 10px!important;
    }
    .agreeItem {
        .ivu-checkbox-wrapper {
            line-height: 20px;
            font-size: 12px;
        }
    }
</style>